import { createSelector } from 'reselect'

const getCampaignsState = state => state.campaigns

export const getCampaignData = createSelector(
  [getCampaignsState],
  campaigns => (campaigns ? campaigns.data : null)
)

export const getCampaignFetchError = createSelector(
  [getCampaignsState],
  campaigns => (campaigns ? campaigns.error : null)
)

export const isFetchingCampaigns = createSelector(
  [getCampaignsState],
  campaigns => (campaigns ? campaigns.isFetching : null)
)

export const getCampaignDates = createSelector(
  [getCampaignData],
  campaign => (campaign ? campaign.dateLimits : null)
)
